import { render, staticRenderFns } from "./CoffeeIcon.vue?vue&type=template&id=278284f8&"
import script from "./CoffeeIcon.vue?vue&type=script&lang=ts&"
export * from "./CoffeeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('278284f8', component.options)
    } else {
      api.reload('278284f8', component.options)
    }
    module.hot.accept("./CoffeeIcon.vue?vue&type=template&id=278284f8&", function () {
      api.rerender('278284f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/CoffeeIcon.vue"
export default component.exports